import { Db_PropertyType } from '../models/datapoint/dbPropertyType';
export class Db_PropertyTypesUtil {
    private static instance: Db_PropertyTypesUtil;

    static getInstance(): Db_PropertyTypesUtil {
        if (!Db_PropertyTypesUtil.instance) {
            Db_PropertyTypesUtil.instance = new Db_PropertyTypesUtil();
        }

        return Db_PropertyTypesUtil.instance;
    }

    /**
    * Db_PropertyTypesUtil is a singleton class, so use Db_PropertyTypesUtil.getInstance() method instead of creating new Db_PropertyTypesUtil().
    */
    private constructor() {

    }

    getDb_PropertyTypeKey(db_PropertyType: Db_PropertyType): string {
        return db_PropertyType.propertyType_Cd;
    }

    copy(db_PropertyTypes: Array<Db_PropertyType>): Array<Db_PropertyType> {
        let db_PropertyTypesTmp: Array<Db_PropertyType> = new Array<Db_PropertyType>();

        for (var i: number = 0; i < db_PropertyTypes.length; i++) {
            db_PropertyTypesTmp.push(Db_PropertyType.parse(db_PropertyTypes[i]));
        }

        return db_PropertyTypesTmp;
    }

    copyFrom(db_PropertyTypes: Array<Db_PropertyType>, db_PropertyTypesTmp: Array<Db_PropertyType>): void {
        let db_PropertyTypesMap: Map<string, Db_PropertyType> = new Map();

        let db_PropertyTypesLength: number = db_PropertyTypes.length;
        for (let i: number = 0; i < db_PropertyTypesLength; i++) {
            db_PropertyTypesMap.set(db_PropertyTypes[i].propertyType_Cd, db_PropertyTypes[i]);
        }
        db_PropertyTypes.splice(0, db_PropertyTypes.length);

        let db_PropertyTypesTmpLength: number = db_PropertyTypesTmp.length;
        for (let i: number = 0; i < db_PropertyTypesTmpLength; i++) {
            let db_PropertyTypeTmp: Db_PropertyType = db_PropertyTypesTmp[i] as Db_PropertyType;

            let db_PropertyType: Db_PropertyType = db_PropertyTypesMap.get(db_PropertyTypeTmp.propertyType_Cd);
            if (db_PropertyType) {
                db_PropertyType = Db_PropertyType.parse(db_PropertyTypeTmp);
            } else {
                db_PropertyType = Db_PropertyType.parse(db_PropertyTypeTmp);
            }

            db_PropertyTypes.push(db_PropertyType);
        }
    }

    compare(db_PropertyTypes: Array<Db_PropertyType>, db_PropertyTypesTmp: Array<Db_PropertyType>): string {
        let db_PropertyTypesLength = db_PropertyTypes.length;
        let db_PropertyTypesTmpLength = db_PropertyTypesTmp.length;

        if (db_PropertyTypesLength != db_PropertyTypesTmpLength) {
            return 'Obj_Db_Properties length is different.';
        }

        for (let i: number = 0; i < db_PropertyTypesLength; i++) {
            let db_PropertyType: Db_PropertyType = db_PropertyTypes[i];
            let db_PropertyTypeTmp: Db_PropertyType = db_PropertyTypesTmp[i];

            if (db_PropertyType.compare(db_PropertyTypeTmp) != '') {
                return 'db_PropertyTypes [' + i + '] is not equal.'
            }
        }

        return '';
    }

    toString(db_PropertyTypes: Array<Db_PropertyType>): string {
        let str: string = '';

        str += 'Db_PropertyTypes length: ' + db_PropertyTypes.length + ' ';

        for (let i: number = 0; i < db_PropertyTypes.length; i++) {
            str += db_PropertyTypes[i].toString();
        }

        return str;
    }
}